import { MovimentacaoService } from './../../../_core/services/movimentacao.service';
import { Usuario } from './../../../_core/models/usuario';
import { PageService } from './../../../_core/services/page.service';
import { Page } from './../../../_core/models/page';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TelaDeInconsistenciaUserModalComponent } from '../tela-de-inconsistencia-user-modal/tela-de-inconsistencia-user-modal.component';

@Component({
  selector: 'app-tela-de-inconsistencias-usuario',
  templateUrl: './tela-de-inconsistencias-usuario.component.html',
  styleUrls: ['./tela-de-inconsistencias-usuario.component.scss']
})
export class TelaDeInconsistenciasUsuarioComponent implements OnInit {
  user!:Usuario;
  pagina = 1;
  total = 10;
  page!: Page;
  ativo = true;
  pesquisa = '';
  loading = true;
  constructor(
    private pageService: PageService,
    private movimentacaoService:MovimentacaoService,
    private modalService:NgbModal) {
    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
   }

  ngOnInit() {
    
    this.ativo = true;
    this.page = new Page();
    this.page.currentPage = this.pagina;
    this.page.pageSize = this.total;
    this.page.ativo = this.ativo;
    this.page.currentPage = 1;
    this.setPage(this.page.currentPage);
    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
  }
  setPage(page: number): void {
    this.loading = true;
    this.page.currentPage = page;
    //console.log/this.user.cD_MATRICULA)
      this.movimentacaoService.mov_getInconOrigAll(this.user.cD_MATRICULA,this.page)
      .subscribe(
        data => {
          this.page = data;
          this.page = this.pageService.getPager(this.page);
          this.loading = false;
        },
        err => {
          this.loading = false;
        }
      )

  }
  paginaAtual(pagina: any) {
    return this.page.currentPage === pagina;
  }
  pesquisar() {
    this.page.pesquisa = this.pesquisa;
    this.page.ativo = this.ativo;
    this.page.dados = [];
    this.setPage(1);
  }
  atualizar() {
    this.pesquisa = '';
    this.ativo = true;
    this.page.dados = [];
    this.pesquisar();
  }
  // confirmar(cD_BPM_BEM_PATRIMONIAL:number) {
    
  //   Swal.fire({
  //     title: 'Deseja confirmar essa inconsistência?',
  //     confirmButtonText: 'Confirmar',
  //     showCancelButton: true,
  //     cancelButtonText: 'Cancelar',
  //     icon: 'info',
  //   }).then((result)=>{
  //     if(result.value){
  //       this.movimentacaoService.mov_confirmInconOrig(cD_BPM_BEM_PATRIMONIAL).
  //       subscribe(
  //         data => {
  //           const msg:string = 'Confirmado com sucesso!'
  //           Swal.fire(
  //             'Sucesso!',
  //             msg,
  //             'success'
  //           ).then(() => {
  //             this.atualizar();
  //           });
  //         },
  //         err => {
  //           ////console.log/JSON.stringify(err))
  //           let msg:string = 'Erro ao confirmar,tente novamente mais tarde!'
  //           if(err.status == 401){
  //             return msg = err.error;
  //           }
  //           Swal.fire('Erro',msg,'error').then(()=>{
  //             this.loading = false;
  //           });
  //           ////console.log/JSON.stringify(err))
  //         }
  //       )
  //     }
  //   })
  // }

  // cancelar(cD_BPM_BEM_PATRIMONIAL:number) { 
  //   Swal.fire({
  //     title: 'Deseja cancelar essa inconsistência?',
  //     confirmButtonText: 'Sim',
  //     showCancelButton: true,
  //     cancelButtonText: 'Não',
  //     icon: 'info',
  //   }).then((result)=>{
  //     if(result.value){
  //       this.movimentacaoService.mov_cancelIncon(cD_BPM_BEM_PATRIMONIAL).
  //       subscribe(
  //         data => {
  //           const msg:string = 'Cancelado com sucesso!'
  //           Swal.fire(
  //             'Sucesso!',
  //             msg,
  //             'success'
  //           ).then(() => {
  //             this.atualizar();
  //           });
  //         },
  //         err => {
  //           ////console.log/JSON.stringify(err))
  //           let msg:string = 'Erro ao cancelar,tente novamente mais tarde!'
  //           if(err.status == 401){
  //             return msg = err.error;
  //           }
  //           Swal.fire('Erro',msg,'error').then(()=>{
  //             this.loading = false;
  //           });
  //           ////console.log/JSON.stringify(err))
  //         }
  //       )
  //     }
  //   })
  // }
  abreEdicao(nR_BPM_BEM_PATRIMONIAL:number,cD_BPM_MOVIMENTACAO_PATRIMONIAL:number){ 
    const modalRef = this.modalService.open(TelaDeInconsistenciaUserModalComponent, {
    size: 'lg',
    backdrop: 'static',
  });
  modalRef.componentInstance.nR_BPM_BEM_PATRIMONIAL = nR_BPM_BEM_PATRIMONIAL;
  modalRef.componentInstance.cD_BPM_MOVIMENTACAO_PATRIMONIAL = cD_BPM_MOVIMENTACAO_PATRIMONIAL;
  modalRef.result.then(() => this.atualizar());
  }
}
